import { DateTime } from 'luxon'

export function formattedDate(millis) {
    const dateTime = DateTime.fromMillis(millis)
    return `${dateTime.toFormat('cccc, LLLL d')} ${dateTime.year - 400} ${dateTime.toFormat('h:mm:ss a')}`
}
